const ApiTags = {
  EVENT_LIST: 'Events',
  BRANCHES: 'Branches'
};

export default ApiTags;
